// Libs
import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Title } from '../../../../components/atoms/title';

export function UserReports({ userData }) {
  const reports = userData?.reports;

  const formatDate = dateString => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return (
    userData.reports.length > 0 && (
      <Grid style={{ marginBottom: '32px' }}>
        <Title>Denúncias</Title>
        <ol style={{ marginLeft: '16px' }}>
          {reports
            ? reports.map(report => (
                <Typography variant='inherit' color='textSecondary' key={report.created_at}>
                  <li style={{ marginBottom: '8px' }}>
                    <p>
                      <b>Data:</b> {formatDate(report.created_at)}
                    </p>{' '}
                    <p>
                      {' '}
                      <b>Motivo:</b> {report.reason}
                    </p>
                    {report.explanation && (
                      <p>
                        <b>Explicação:</b> {report.explanation}
                      </p>
                    )}
                  </li>
                </Typography>
              ))
            : 'Nenhuma denúncia encontrada'}
        </ol>
      </Grid>
    )
  );
}
